var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateCheckSvgrepoCom1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificate-check-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.625 11.5L10.5417 13.4167L14.375 9.58333M11.5 2.875L13.3305 4.66849L15.8125 4.03053L16.501 6.49899L18.9694 7.1875L18.3315 9.66949L20.125 11.5L18.3315 13.3305L18.9694 15.8125L16.501 16.501L15.8125 18.9694L13.3305 18.3315L11.5 20.125L9.66949 18.3315L7.1875 18.9694L6.49899 16.501L4.03053 15.8125L4.66849 13.3305L2.875 11.5L4.66849 9.66949L4.03053 7.1875L6.49899 6.49899L7.1875 4.03053L9.66949 4.66849L11.5 2.875Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateCheckSvgrepoCom1);
export default __webpack_public_path__ + "static/media/certificate-check-svgrepo-com 1.f02120940b8c1487c6bd7d1958b5c869.svg";
export { ForwardRef as ReactComponent };